import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('status-toast', {
  root: {
    variants: { status: ['success', 'warning', 'error'] },
    states: ['mobile'],
  },
  toast: { states: ['mobile'] },
  content: {},
  icon: {},
  text: {},
  action: {},
  actionButton: {},
});
